
import { Component, Vue } from 'vue-property-decorator';
import NoSearchBar from '@/layouts/nosearchbar/NoSearchBar.vue';

@Component({
  components: {
    NoSearchBar,
  },
})
export default class WorkflowView extends Vue {
    private exitPage() {
      this.$router.push({
        path: '/datalake/workflows',
      });
    }

}
